import type { FaireProductEntity } from "../../entity_types/product";

export const p_5y6dmjsnqm: FaireProductEntity = {
  token: "p_5y6dmjsnqm",
  type: "product",
  name: "Watercolor Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/f0709aec1ddf5229a348fca507d9b7efab65c507ad611a578b47695d0e810d2f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/27182c29f4e6feb9bdbed5e9417d32f5a84a70ffc5ea241a59c30d0fb2f637de.jpeg",
    "https://cdn.faire.com/fastly/e8e0c0b06386f423b21ead9bb825ba60fdbd97e1c618156ca1969c9ad75c5f07.jpeg",
    "https://cdn.faire.com/fastly/115d8a7243b3c346110806892fa18c5881848b756cc32c5d0ec55fe1dda4b082.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:20.446Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
